import type { DateValue } from "react-aria-components";
import {
  DateInput as RACDateInput,
  type DateInputProps as RACDateInputProps,
  DateRangePicker as RACDateRangePicker,
  type DateRangePickerProps as RACDateRangePickerProps,
  DateSegment as RACDateSegment,
  type DateSegmentProps as RACDateSegmentProps,
  Dialog as RACDialog,
  type DialogProps as RACDialogProps,
  Group as RACGroup,
  type GroupProps as RACGroupProps,
  Label as RACLabel,
  type LabelProps as RACLabelProps,
  Popover as RACPopover,
  type PopoverProps as RACPopoverProps,
} from "react-aria-components";

export interface DateRangePickerProps<T extends DateValue> extends RACDateRangePickerProps<T> {}
export interface DateRangePickerGroupProps extends RACGroupProps {}
export interface DateRangePickerLabelProps extends RACLabelProps {}
export interface DateRangePickerPopoverProps extends RACPopoverProps {}
export interface DateRangePickerDialogProps extends RACDialogProps {}
export interface DateRangePickerInputProps extends RACDateInputProps {}
export type DateRangePickerSegmentProps = RACDateSegmentProps;

export function DateRangePicker<T extends DateValue>(props: DateRangePickerProps<T>) {
  return <RACDateRangePicker {...props} />;
}

export function DateRangePickerGroup(props: DateRangePickerGroupProps) {
  return <RACGroup {...props} />;
}

export function DateRangePickerLabel(props: DateRangePickerLabelProps) {
  return <RACLabel {...props} />;
}

export function DateRangePickerPopover(props: DateRangePickerPopoverProps) {
  return <RACPopover {...props} />;
}

export function DateRangePickerDialog(props: DateRangePickerDialogProps) {
  return <RACDialog {...props} />;
}

export function DateRangePickerInput(props: DateRangePickerInputProps) {
  return <RACDateInput {...props} />;
}

export function DateRangePickerSegment(props: DateRangePickerSegmentProps) {
  return <RACDateSegment {...props} />;
}
